import { PRODUCTION, DEVELOPMENT, LOCAL_SANCTIONS_URL } from "./const";
import { isEmpty } from "lodash";

export function getSanctionsUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const SANCTIONS_URL = !!process.env.REACT_APP_SANCTIONS_URL && process.env.REACT_APP_SANCTIONS_URL !== "" ? process.env.REACT_APP_SANCTIONS_URL : LOCAL_SANCTIONS_URL;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return SANCTIONS_URL;
      case PRODUCTION:
        return SANCTIONS_URL;
      default:
        return SANCTIONS_URL;
    }
  } else {
    return LOCAL_SANCTIONS_URL;
  }
}

export const getSanctionsUrlValue = () => {
  return getSanctionsUrl();
};
